import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import css from './AddCategoryModal.css';
import StyledButton from 'common/StyledButton';
import Modal from 'react-modal';
import Footer from 'common/Footer';
import ModalHeader from './ModalHeader';
import useStarfishAPI from 'hooks/useStarfishAPI';
import Icon from 'SF/MaterialIcon';

// Endpoint URL
const URL = `../api/reserved-time-categories`;

const AddCategoryModal = (props) => {
  Modal.setAppElement(document.getElementById('main-center'));

  const [response, callAPI] = useStarfishAPI({isNewAPI: true});

  const titleLengthHasExceeded = props.title.length > 70;
  const disabled = (props.title === "" || titleLengthHasExceeded) || response.pending;

  const isEdit = !!props.id;

  const onSave = () => {
    if ( disabled ) return;

    // Save category
    callAPI(`${URL}${isEdit ? `/${props.id}` : ""}`, {
      method: isEdit ? "PUT" : "POST",
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...(props.id && { id: props.id }),
        title: props.title,
        description: props.description,
        enabled: props.enabled
      })
    });
  }

  useEffect(() => {
    if ( response.success ) {
      props.fetchCategories();
      props.closeModal();
    }
  }, [response.success]);

  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={props.closeModal}
      overlayClassName={css['overlay']}
      className={css['modal']}>
        <div className={css['container']}>
          <div className={css['content']}>
            <ModalHeader closeModal={props.closeModal} isEdit={isEdit} />
            <div className={css['form']}>
              <div className={css['input']}>
                <label htmlFor="add-category-name"><span>*</span> Category Name</label>
                <input
                  id="add-category-name"
                  type="text"
                  value={props.title}
                  className={titleLengthHasExceeded ? css['error'] : null}
                  onChange={e => props.setTitle(e.target.value)}
                  placeholder="Required"
                  autoFocus
                />
                {titleLengthHasExceeded && <div><Icon aria-hidden="true" icon="error"/> <span>Category Name must be fewer than 70 characters.</span></div>}
              </div>
              <div className={css['input']}>
                <label htmlFor="add-category-description">Description</label>
                <textarea
                  id="add-category-description"
                  value={props.description}
                  onChange={e => props.setDescription(e.target.value)}
                />
              </div>
              <div className={css['checkbox-container']}>
              <input
                id="add-category-checkbox" 
                data-testid="add-category-checkbox"
                type="checkbox"
                checked={props.enabled}
                onChange={e => props.setEnabled(e.target.checked)}
              />
              <label htmlFor="add-category-checkbox">
                Enabled
              </label>
            </div>
            </div>
          </div>
          <Footer 
            primaryButton={(
              <StyledButton
                data-role="saveReservedTimeCategory"
                aria-disabled={disabled}
                onClick={onSave}>
                {response.pending ? "Saving..." : "Save"}
              </StyledButton>
            )}
            secondaryButton={(
              <StyledButton 
                asLink 
                onClick={props.closeModal}>
                Cancel
              </StyledButton>
            )}
          />
        </div>
    </Modal>
  );
}

AddCategoryModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  id: PropTypes.number,
  setId: PropTypes.func.isRequired,
  title: PropTypes.string,
  setTitle: PropTypes.func.isRequired,
  description: PropTypes.string,
  setDescription: PropTypes.func.isRequired,
  enabled: PropTypes.bool.isRequired,
  setEnabled: PropTypes.func.isRequired,
  fetchCategories: PropTypes.func.isRequired,
};

export default AddCategoryModal;
